<!-- ChartComponent.vue -->
<template>
  <div>
    <apexchart ref="chart" type="bar" width="400" height="315px !important" :options="chartOptions" :series="series" />
  </div>
</template>
<script>
import VueApexCharts from 'vue3-apexcharts'

export default {
  name: 'ChartComponent',
  components: {
    apexchart: VueApexCharts,
  },
  props:{
    chartData:Object,
    required: false, // This can be set to false if you want to allow the absence of this prop
      default: () => {
        return {
          series: [],
          categories:[], // Default value for chat-data
        }
      },
  },
  
  data() {
    return {
      series: this.$props.chartData ? this.$props.chartData.series : [],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0,
            },
          },
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: 'end',
            borderRadiusWhenStacked: 'last',
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: '13px',
                  fontWeight: 900,
                },
              },
            },
          },
        },
        xaxis: {
          categories: this.$props.chartData ? this.$props.chartData.categories :  [],
        },
        legend: {
          position: 'bottom', // Move the legend to the bottom
          horizontalAlign: 'center', // Center the legend horizontally
          offsetY: 10, // Adjust vertical positioning if needed
        },
        fill: {
          opacity: 1,
        },
        colors: [
  '#a42527', // from #bb282e → #801217
  '#3C84F4', // from #4D96FF → #1A73E8
  '#315B94', // from #3F72AF → #1F4C7C
  '#ED5757', // from #FF6B6B → #D84343
  '#F5C71A', // from #FFD93D → #E6B800
  '#54BA63', // from #6BCB77 → #3BA94E
  '#3F85F0', // from #4D96FF → #1A73E8 (again for harmony)
  '#6D2F54', // from #843B62 → #5E2446
  '#87506C', // from #9F5F80 → #743958
  '#D87A4B', // from #F08A5D → #C46B3D
  '#A72F4F', // from #B83B5E → #8E2947
  '#3F85F0', // from #4D96FF → #1A73E8
  '#00B188', // from #00C897 → #009E77
  '#E56C6C', // from #F38181 → #D65A5A
  '#E44848', // from #FF6B6B → #C62828
  '#F1E24F', // from #F9ED69 → #E2D34B
  '#35A7BC', // from #3EC1D3 → #2695A5
  '#E28700', // from #FF9A00 → #CC7A00
  '#7E379F', // from #8E44AD → #6C2E89
  '#2DBF68',  // from #2ECC71 → #27AE60
],

      },

    }
  },
  mounted(){
    console.log(this.$props.chartData)
  },
}
</script>


<style scoped>
/* Add any styles specific to this component */
</style>
